




















import Vue, { PropType } from 'vue';

import EmployeeChartContainer from '@/components/employee/chart/EmployeeChartContainer.vue';

import { EmployeeNode } from '@/models';

export default Vue.extend({
  components: { EmployeeChartContainer },
  name: 'EmployeeOrgChartPage',

  props: {
    employeeTrees: Array as PropType<EmployeeNode[]>,
    loading: Boolean
  },

  computed: {
    isLoading: {
      get(): boolean {
        return this.loading;
      },
      set(value: boolean) {
        this.$emit('update:loading', value);
      }
    }
  }
});
